<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div>
    <p v-if="siteTitle" class="site-title-label">
      {{ siteTitle }}
    </p>
    <FavoriteFileList
      v-if="filter === 'file'"
      :site-id="siteId"
      :url-resolver="urlResolver"
    />
    <FavoriteFolderList
      v-else-if="filter === 'folder'"
      :site-id="siteId"
      :url-resolver="urlResolver"
    />
    <FavoriteSiteList
      v-else-if="filter === 'site'"
      :url-resolver="urlResolver"
    />
  </div>
</template>

<script>
import FavoriteFileList from "@/components/dashboard/widgets/FavoriteFileList.vue";
import FavoriteFolderList from "@/components/dashboard/widgets/FavoriteFolderList.vue";
import FavoriteSiteList from "@/components/dashboard/widgets/FavoriteSiteList.vue";
import workspaceService from "@/services/WorkspaceService.js";

export default {
  name: "FavoriteList",
  components: {
    FavoriteFileList,
    FavoriteFolderList,
    FavoriteSiteList,
  },
  props: {
    filter: {
      type: String,
      default: "file",
      validator: (value) => ["file", "folder", "site"].includes(value),
    },
    siteId: {
      type: String,
      default: "",
    },
    urlResolver: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      siteTitle: "",
    };
  },
  watch: {
    siteId: {
      immediate: true,
      handler(newSiteId) {
        this.resolveSiteTitle(newSiteId);
      },
    },
  },
  methods: {
    resolveSiteTitle(siteId) {
      if (!siteId) {
        this.siteTitle = "";
        return;
      }
      workspaceService
        .getWorkspace(siteId)
        .then((site) => {
          this.siteTitle = site.title || site.id;
        })
        .catch(() => {
          this.siteTitle = siteId;
        });
    },
  },
};
</script>

<style scoped>
.site-title-label {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  color: var(--p-text-muted-color);
}
</style>
